/**
 * Created by User on 18/02/2016.
 */
import Observer from '../utils/Observer';
import AdConsts from '../AdConsts';
import LiveAdPlugin from '../plugins/LiveAdPlugin';
import IMAElement from './elements/IMAElement';

export default Block;

function Block(videoState, type, timeStart, timeEnd, timeUnit, timeout) {
  var self = this;
  var _members = [];
  var _type = type;
  var _videoState = videoState;
  var _timeStart = timeStart;
  var _timeEnd = timeEnd;
  var _timeUnit = timeUnit;
  var _timeout = timeout;
  var _globalTimeout = -1;
  var _repeatInterval = void 0;
  var _blockEnd = -1;
  var _memberIndex = 0;
  var _linear = type != AdConsts.OVERLAY;
  var _errorMembersCount = 0;
  var _countdownTimerID = null;
  var _countdownTimerPaused = false;
  var _passedSeconds = 0;
  var _zeroAllowBlockIndex = -1;
  var _showed = false;
  var _repeatIntervalTimeoutID = null;
  var _blockIsStopping = false;
  var _cacheBoost = Math.floor(new Date().getTime() / 1000) + Math.floor(Math.random() * 214748364);
  var _sizeInfo = null;



  //this variable using for calculation of current timestamp, coz main video staying on pause when midrolls play
  var _liveAdStartedTimestamp = 0;

  var _currentMember = null;

  this.dispose = function () {
    Observer.off([ AdConsts.MEMBER_ERROR, AdConsts.MEMBER_READY_TO_SHOW, AdConsts.MEMBER_COMPLETE ], _memberListener);
    if (_currentMember) {
      _memberListener({ name: AdConsts.MEMBER_COMPLETE, data: _currentMember });
    }

    _zeroAllowBlockIndex = -1;
    _showed = false;
    _currentMember = null;
    _countdownTimerID = null;
    _passedSeconds = 0;
    _blockIsStopping = false;
    if (_repeatIntervalTimeoutID) {
      clearTimeout(_repeatIntervalTimeoutID);
    }
    if (_countdownTimerID) {
      clearInterval(_countdownTimerID);
      _countdownTimerID = null;
      Observer.off('property:state', onPlayerStateChange);
    }
    if (_members) {
      for (var i = 0; i < _members.length; ++i) {
        _members[i].dispose();
      }
      _members.length = 0;
      _members = null;
    }
  };

  var _sortFunction = function (a, b) {
    if (a.priority > b.priority) {
      return 1;
    }
    if (a.priority < b.priority) {
      return -1;
    }
    return 0;
  };

  this.addAdPlaylistElement = function (element) {
    _members.push(element);
    _members.sort(_sortFunction);
    _timeout = _members[0].timeout;
    _globalTimeout = _members[0].globalTimeout;
    _videoState = _members[0].videoState;
    _timeUnit = _members[0].timeUnit;
    _repeatInterval = _members[0].repeatInterval;
    _blockEnd = _members[0].blockEnd || -1;
  };

  this.show = function (sizeInfo) {
    _sizeInfo = sizeInfo;
    _zeroAllowBlockIndex = -1;
    Observer.on([ AdConsts.MEMBER_ERROR, AdConsts.MEMBER_READY_TO_SHOW, AdConsts.MEMBER_COMPLETE ], _memberListener);
    if (_memberIndex == 0) {
      _errorMembersCount = 0;
      Observer.emit(AdConsts.BLOCK_STARTED, self);

      if (LiveAdPlugin && LiveAdPlugin.isLiveAd && _blockEnd > 0) {
        _liveAdStartedTimestamp = new Date().getTime();
        Observer.on('player:timeUpdate', onPlayerTimeUpdate);
      }
    }
    _currentMember = _members[_memberIndex++];
    if (_currentMember) {
      _blockIsStopping = false;
      _currentMember.show(_memberIndex, _cacheBoost, _sizeInfo);
    }
  };

  this.currentMemberCompleted = function () {
    if (_currentMember) {
      _currentMember.completed();
    }
  };

  this.stopBlock = function () {
    _blockIsStopping = true;
    self.currentMemberCompleted();
  };

  this.getMemberNumber = function (member) {
    var result = -1;
    var failedMembersCount = 0;
    var i, l;
    for (i = 0, l = _members.length; i < l; ++i) {
      if (member == _members[i]) {
        result = i + 1 - failedMembersCount; //'+ 1' -- counting starts from 1 not 0.
        break;
      } else if (_members[i].failed) {
        ++failedMembersCount;
      }
    }
    return result;
  };

  this.getMembersCount = function (member) {
    var result = 0;
    if (_zeroAllowBlockIndex != -1) {
      result = _zeroAllowBlockIndex + 1;
    } else {
      result = self.membersCount - _errorMembersCount;
    }
    return result;
  };

  var _memberListener = function (event) {
    if (!_currentMember) {
      _endBlock();
      return;
    }
    switch (event.name) {
      case AdConsts.MEMBER_READY_TO_SHOW:
        if (!(_currentMember.element instanceof IMAElement)) {
          _linear = _currentMember.linear;
        }
        var allowBlockArray = _currentMember.getExtensionValue(AdConsts.ALLOW_BLOCK);
        var allowBlock = true;
        try {
          if (Array.isArray(allowBlockArray) && allowBlockArray.length > 0) {
            for (var i = 0, l = allowBlockArray.length; i < l; ++i) {
              allowBlock &= parseInt(allowBlockArray[i]);
            }
            allowBlock = !!allowBlock;
          } else if (typeof allowBlockArray === 'string') {
            allowBlock = parseInt(allowBlockArray) == 1;
          } else {
            allowBlock = true;
          }
        } catch (error) {
          allowBlock = true;
        }
        if (!allowBlock) {
          _zeroAllowBlockIndex = _members.indexOf(event.data);
        }

        if ((_type == AdConsts.MIDROLL || _type == AdConsts.POSTROLL) && !_countdownTimerID && videoState != AdConsts.STATE_COMPLETE
					&& self.getMemberNumber(_currentMember) == 1) {
          registerCountdownTimer();
          _onCountdownTimer();
        } else if (_type == AdConsts.OVERLAY && _currentMember.element.vastData
					&& typeof _currentMember.element.vastData.mediaFile[0].type === 'string'
					&& _currentMember.element.vastData.mediaFile[0].type.indexOf('video') != -1) {
          _memberListener({ name: AdConsts.MEMBER_ERROR, data: _currentMember });
        } else {
          Observer.emit(AdConsts.BLOCK_STARTING_NEW_ELEMENT, self);
        }
        break;
      case AdConsts.MEMBER_COMPLETE:
      case AdConsts.MEMBER_ERROR:
        if (_countdownTimerID) {
          clearInterval(_countdownTimerID);
          _countdownTimerID = null;
        }
        if (event.type == AdConsts.MEMBER_ERROR) {
          _currentMember.failed = true;
        }
        _currentMember = null;

        if (event.name == AdConsts.MEMBER_ERROR) {
          ++_errorMembersCount;
        }
        if (!_blockIsStopping && _memberIndex < _members.length && _memberIndex != _zeroAllowBlockIndex + 1) {
          //if this is second member in block, we don't need to again run timer
          //so this is not pretty fine hook, but it works
          if (_type == AdConsts.MIDROLL || _type == AdConsts.POSTROLL) {
            _countdownTimerID = 1;
          }
          self.show(_sizeInfo);
          if (_countdownTimerID) {
            _countdownTimerID = null;
          }
        } else {
          _endBlock();
        }
        break;
    }
  };

  var _endBlock = function () {
    if (_type != AdConsts.PAUSE_ROLL && _type != AdConsts.AFTER_PAUSE_ROLL) {
      if (_repeatInterval > 0) {
        if (_repeatIntervalTimeoutID) {
          clearTimeout(_repeatIntervalTimeoutID);
        }
        _repeatIntervalTimeoutID = setTimeout(onRepeatIntervalTimeout, _repeatInterval * 1000);
      }
      _showed = true;
    }
    _memberIndex = 0;
    _liveAdStartedTimestamp = 0;

    if (!self.errorInBlock) {
      if (_globalTimeout > 0 && !_blockIsStopping) {
        var observer = Observer.getObserverInstance();
        var globalTimeouts = observer.get(AdConsts.PROP_GLOBAL_TIMEOUTS);
        if (globalTimeouts) {
          globalTimeouts = Object.assign({}, globalTimeouts);
        } else {
          globalTimeouts = {};
        }
        globalTimeouts[_type] = Date.now() + _globalTimeout * 1000;
        observer.set(AdConsts.PROP_GLOBAL_TIMEOUTS, globalTimeouts);
      }
    }


    Observer.off('player:timeUpdate', onPlayerTimeUpdate);
    Observer.off([ AdConsts.MEMBER_ERROR, AdConsts.MEMBER_READY_TO_SHOW, AdConsts.MEMBER_COMPLETE ], _memberListener);
    Observer.emit(AdConsts.BLOCK_ENDED, self);

    if (_type === AdConsts.PAUSE_ROLL || _type === AdConsts.AFTER_PAUSE_ROLL) {
      _cacheBoost = Math.floor(new Date().getTime() / 1000) + Math.floor(Math.random() * 214748364);
    }
  };

  var _onCountdownTimer = function () {
    var deltaSeconds = Block.SECONDS_TO_START - _passedSeconds++;
    if (deltaSeconds > 0) {
      Observer.emit(AdConsts.AD_WILL_START_IN, deltaSeconds);
    } else {
      Observer.off('property:state', onPlayerStateChange);
      clearInterval(_countdownTimerID);
      _countdownTimerID = null;
      _passedSeconds = 0;
      Observer.emit(AdConsts.BLOCK_STARTING_NEW_ELEMENT, self);
    }
  };

  function onRepeatIntervalTimeout() {
    _showed = false;
  }

  function registerCountdownTimer() {
    _countdownTimerID = setInterval(_onCountdownTimer, 1000);
    Observer.on('property:state', onPlayerStateChange);
  }

  function onPlayerStateChange(event) {
    if (event.data != AdConsts.PLAYER_STATE_PLAYING) {
      if (_countdownTimerID) {
        clearInterval(_countdownTimerID);
        _countdownTimerPaused = true;
      }
    } else {
      if (_countdownTimerPaused && _currentMember) {
        _countdownTimerPaused = false;
        _countdownTimerID = setInterval(_onCountdownTimer, 1000);
      }
    }
  }

  function onPlayerTimeUpdate(event) {
    var dT = Math.round((new Date().getTime() - _liveAdStartedTimestamp) / 1000);
    var currentTimestamp = LiveAdPlugin.getCurrentTimestamp() + dT;
    if (currentTimestamp >= _blockEnd) {
      _liveAdStartedTimestamp = 0;
      Observer.off('player:timeUpdate', onPlayerTimeUpdate);
      _endBlock();
    }
  }

  Object.defineProperties(this, {
    'currentMember': {
      enumerable: true,
      configurable: true,
      get: function () {
        return _currentMember;
      }
    },
    'errorInBlock': {
      enumerable: true,
      configurable: true,
      get: function () {
        return _errorMembersCount >= _members.length;
      }
    },

    'type': {
      enumerable: true,
      configurable: true,
      get: function () {
        return _type;
      }
    },
    'videoState': {
      enumerable: true,
      configurable: true,
      get: function () {
        return _videoState;
      }
    },
    'linear': {
      enumerable: true,
      configurable: true,
      get: function () {
        return _linear;
      }
    },
    'timeStart': {
      enumerable: true,
      configurable: true,
      get: function () {
        return _timeStart;
      }
    },
    'timeEnd': {
      enumerable: true,
      configurable: true,
      get: function () {
        return _timeEnd;
      }
    },
    'timeUnit': {
      enumerable: true,
      configurable: true,
      get: function () {
        return _timeUnit;
      }
    },
    'timeout': {
      enumerable: true,
      configurable: true,
      get: function () {
        return _timeout;
      }
    },
    'globalTimeout': {
      enumerable: true,
      configurable: true,
      get: function () {
        return _globalTimeout;
      }
    },
    'blockEnd': {
      enumerable: true,
      configurable: true,
      get: function() {
        return _blockEnd;
      }
    },
    'currentIndex': {
      enumerable: true,
      configurable: true,
      get: function () {
        return _memberIndex - 1;
      }
    },
    'membersCount': {
      enumerable: true,
      configurable: true,
      get: function () {
        return _members.length;
      }
    },
    'members': {
      enumerable: true,
      configurable: true,
      get: function () {
        return _members;
      }
    },
    'showed': {
      enumerable: true,
      configurable: true,
      get: function () {
        return _showed;
      }
    },
    'blockIsStopping': {
      enumerable: true,
      configurable: true,
      get: function () {
        return _blockIsStopping;
      }
    }
  });
}
Block.prototype.constructor = Block;
Block.SECONDS_TO_START = 5;
